import React from 'react'
import './Ramz.css'


import {Outlet,NavLink} from 'react-router-dom'



const Ramz=()=> {
  return (
    <div className="Ramz">
      <div className="navbar1">
        <ul>
          <li><NavLink to="bayroq">Bayroq</NavLink></li>
          <li><NavLink to="gerb">Gerb</NavLink></li>
          <li><NavLink to="madhiya">Madhiya</NavLink></li>
        </ul>
      </div>
        
    <Outlet/>
        
    
    </div>
  )
}
export default Ramz
